function adicionarDiasDataVencimento(date: Date, quantidade: number): Date {
  const auxDataVencimento = date;
  date.setDate(auxDataVencimento.getDate() + quantidade);
  console.log(date);
  return date;
}

function gerarDataVencimento(data: Date): string {
  return `${data.getFullYear()}-${tratarString(data.getMonth() + 1)}-${tratarString(data.getDate())}`;
}

function gerarDataVencimentoJurosMora(data: Date, tipo: boolean): string {
  const novaData = new Date(data);
  novaData.setDate(novaData.getDate() + 1);

  return tipo
    ? `${novaData.getFullYear()}-${tratarString(novaData.getMonth() + 1)}-${tratarString(novaData.getDate())}`
    : `${tratarString(novaData.getDate())}/${tratarString(novaData.getMonth() + 1)}/${novaData.getFullYear()}`;
}

function gerarDataEmissao(data: Date): string {
  return `${data.getFullYear()}-${tratarString(data.getMonth() + 1)}-${tratarString(data.getDate())}T${tratarString(data.getHours())}:${tratarString(data.getMinutes())}:${tratarString(data.getSeconds())}-03:00`;
}

function gerarDataString(data: Date): string {
  return `${tratarString(data.getDate() + 1)}/${tratarString(data.getMonth() + 1)}/${data.getFullYear()}`;
}

function tratarData(timestamp: any) {
  var auxDate = new Date();
  auxDate.setTime(timestamp);
  var sData = tratarString(auxDate.getDate()) + '/' + tratarString(auxDate.getMonth() + 1) + '/' + auxDate.getFullYear();
  return sData
}

function tratarDataHora(timestamp: any) {
  var auxDate = new Date();
  auxDate.setTime(timestamp);
  var sData = tratarString(auxDate.getDate()) + '/' + tratarString(auxDate.getMonth() + 1) + '/' + auxDate.getFullYear() + ' às ' + tratarString(auxDate.getHours()) + ':' + tratarString(auxDate.getMinutes());
  return sData
}

function tratarHora(timestamp: any) {
  var auxDate = new Date();
  auxDate.setTime(timestamp);
  var sHora = tratarString(auxDate.getHours()) + ':' + tratarString(auxDate.getMinutes());
  return sHora
}

function tratarString(data) {
  if (data.toString().length < 2) {
    return '0' + data;
  } else {
    return '' + data;
  }
}

export default {
  adicionarDiasDataVencimento,
  gerarDataVencimento,
  gerarDataVencimentoJurosMora,
  gerarDataEmissao,
  gerarDataString,
  tratarData,
  tratarDataHora,
  tratarHora
}
